import React from 'react'
import styled from 'styled-components'

/**
 * 進むアイコン
 */
const ForwardArrowIcon: React.FC<ForwardArrowIconProps> = (props) => {
  return <StyledAllow color={props.color} />
}

export const StyledAllow = styled.div<{
  color?: string
}>`
  width: 10px;
  height: 10px;
  margin-right: 10px;
  border-top: solid 2px
    ${(props): string => (props.color ? props.color : '#c7c7cc')};
  border-right: solid 2px
    ${(props): string => (props.color ? props.color : '#c7c7cc')};
  transform: rotate(45deg);
`

export type ForwardArrowIconProps = {
  color?: string
}

export default ForwardArrowIcon
